import { render, staticRenderFns } from "./BaseProduct.vue?vue&type=template&id=54de6ec2&scoped=true&"
import script from "./BaseProduct.vue?vue&type=script&lang=js&"
export * from "./BaseProduct.vue?vue&type=script&lang=js&"
import style0 from "./BaseProduct.vue?vue&type=style&index=0&id=54de6ec2&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54de6ec2",
  null
  
)

export default component.exports